import { type LoaderFunction, replace } from 'react-router'
import QS from 'qs'
import { links } from '@/utils/link'
import { setPendingStripeConnectCode } from '@/features/billing/stripe-connect/stripe-connect'

/**
 * Data returned by {@link createStripeCallbackLoader} when the callback
 * cannot be handled.
 */
export interface StripeCallbackLoaderData {
  error: Error
}

/**
 * Creates a loader function for the route Stripe redirects back to, which
 * stores the code for the payout method page and redirects there.
 */
export function createStripeCallbackLoader(): LoaderFunction {
  return ({ request }): StripeCallbackLoaderData | Response => {
    const query = QS.parse(new URL(request.url).search, {
      ignoreQueryPrefix: true,
    })
    if (typeof query.code !== 'string' || !query.code) {
      return {
        error: new Error(
          'Something went wrong connecting your Stripe account',
          {
            cause: new Error(
              `Error parsing code from query: code=${String(query.code)}`,
            ),
          },
        ),
      }
    }

    setPendingStripeConnectCode(query.code)
    return replace(links.profileBillingPayoutMethod())
  }
}
